module.exports = __webpack_public_path__ + "static/media/Cribis.cz_grey2.0c3b2d92.svg";